import fuzion_icon from "@assets/imgs/fuzion_icon.png";
import fuzion_logo from "@assets/imgs/fuzion_logo.svg";
import Box from "@mui/material/Box";
import { SxProps } from "@mui/material/styles";
import Text from "@mui/material/Typography";
import { PropsWithChildren } from "react";
import FlexBox from "../FlexBox";

type FuzionLoaderSlots = {
    logo?: React.ReactNode;
}

type FuzionLoaderProps = PropsWithChildren<{
    alternativeText?: string;
    className?: string;
    slots?: FuzionLoaderSlots;
    sx?: SxProps;
}>;
export default function FuzionLoaderComponent({
    alternativeText = "Fuzion_Logo",
    className,
    children,
    slots,
    sx
}: FuzionLoaderProps) {
    return <FlexBox className={className} sx={sx}>
        <Box sx={{
            m: "auto", width: "18rem" // equivalent to w-72 (72 * 0.25rem = 18rem)
        }}>
            <Box
                component="img"
                sx={{
                    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    "@keyframes pulse": {
                        "0%, 100%": {
                            opacity: 1,
                        },
                        "50%": {
                            opacity: 0.5,
                        },
                    },
                }}
                src={fuzion_icon}
                alt={alternativeText}
                loading="lazy"
            />
        </Box>
        {slots?.logo != null ? slots.logo : <Box component="img" src={fuzion_logo}
            sx={{ m: "auto", width: "16rem" }}
            alt="Fuzion Logo"
            loading="lazy"
        />}
        {
            typeof children === "string" ? <Text variant="body1" sx={{ textAlign: "center", mt: 2 }}>{children}</Text> : children
        }
    </FlexBox>;
}
FuzionLoaderComponent.displayName = "FuzionLoader"; 